import { c as _c } from "react/compiler-runtime";
import { ReactElement, memo } from 'react';
import ButtonComponent from '@spa/components/button/button/button.component';
import { ButtonType } from '@spa/components/button/types/ButtonType';
import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import styles from './bazaarvoice-review-empty.component.module.scss';
import useNamespacedIntl from '@spa/lib/i18n/client/hooks/useNamespacedIntl';
export interface Props {
  readonly onWriteReviewClick: () => void;
}
function BazaarvoiceReviewEmptyComponent(t0) {
  const $ = _c(12);
  const {
    onWriteReviewClick
  } = t0;
  const {
    formatMessage
  } = useNamespacedIntl("bazaarvoice-review-section");
  let t1;
  if ($[0] !== formatMessage) {
    t1 = formatMessage("emptyStateMessage");
    $[0] = formatMessage;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className={styles["bazaarvoice-review-empty__message"]}>{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== formatMessage) {
    t3 = formatMessage("writeReviewCta");
    $[4] = formatMessage;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== onWriteReviewClick || $[7] !== t3) {
    t4 = <ButtonComponent buttonType={ButtonType.SECONDARY} text={t3} type="button" onClick={onWriteReviewClick} />;
    $[6] = onWriteReviewClick;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t2 || $[10] !== t4) {
    t5 = <div className={styles["bazaarvoice-review-empty"]}>{t2}{t4}</div>;
    $[9] = t2;
    $[10] = t4;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  return t5;
}
export default memo(BazaarvoiceReviewEmptyComponent);